import type { LayoutChangeEvent } from 'react-native';
import { Pressable, StyleSheet, Text, View } from 'react-native';

import { WorkExperienceItem } from './work-experience-item';
import { colors } from '../theme';
import { inter500, isWeb } from '../utils/platform';
import { WORK_EXPERIENCE } from '../utils/work-experience-data';

type WorkExperienceSectionProps = {
  onLayout: (event: LayoutChangeEvent) => void;
  onPressTitle: () => void;
};

export function WorkExperienceSection({ onLayout, onPressTitle }: WorkExperienceSectionProps) {
  return (
    <View nativeID="work-experience" onLayout={onLayout} style={styles.workExperienceSection}>
      <Pressable onPress={onPressTitle} style={styles.sectionTitleLink}>
        <Text style={styles.sectionTitle}>Work Experience</Text>
      </Pressable>

      <View style={styles.workExperienceList}>
        {WORK_EXPERIENCE.map(item => (
          <WorkExperienceItem
            key={`${item.company}-${item.period}`}
            description={item.description}
            company={item.company}
            location={item.location}
            period={item.period}
            role={item.role}
            techStack={item.techStack}
          />
        ))}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  workExperienceSection: {
    gap: 32,
    paddingVertical: 30,
  },
  sectionTitleLink: {
    alignSelf: 'flex-start',
    ...(isWeb
      ? {
        cursor: 'pointer',
      }
      : null),
  },
  sectionTitle: {
    color: colors.text,
    fontFamily: inter500,
    fontSize: 20,
    fontWeight: '500',
    lineHeight: 24,
  },
  workExperienceList: {
    gap: 48,
    width: '100%',
  },
});
